export const BetStateEnum = {
  Rollbacked: -3,
  WaitingPartner: -2,
  Rejected: -1,
  NotResulted: 0,
  Accepted: 1,
  Returned: 2,
  Lost: 3,
  Won: 4,
  CashedOut: 5,
};

export const BetStateViewEnum = {
  [BetStateEnum.Rejected]: 'Rejected',
  [BetStateEnum.WaitingPartner]: 'Waiting Partner',
  [BetStateEnum.NotResulted]: 'NOT RESULTED',
  [BetStateEnum.Accepted]: 'Pending',
  [BetStateEnum.Returned]: 'Returned',
  [BetStateEnum.Lost]: 'Lost',
  [BetStateEnum.Won]: 'Won',
  [BetStateEnum.CashedOut]: 'Cashout',
  [BetStateEnum.Rollbacked]: 'Rollbacked',
};
